import car1 from "../images/mini-car-01.png";
import car2 from "../images/mini-car-02.png";
import car3 from "../images/mini-car-03.png";

const recommendCars = [
  {
    id: "01",
    carName: "Mini Cooper",
    rentPrice: 32,
    retweet: "132",
    imgUrl: car1,
    percentage: "64",
  },
  {
    id: "02",
    carName: "Porsche 911 Carrera",
    rentPrice: 28,
    retweet: "130",
    imgUrl: car2,
    percentage: "74",
  },
  {
    id: "03",
    carName: "Porsche 911 Carrera",
    rentPrice: 28,
    retweet: "130",
    imgUrl: car3,
    percentage: "74",
  },
];

export default recommendCars;
